import React, { useEffect, useRef, useState } from 'react';
import { FC } from 'react';
import { useRouter } from 'next/router';
import { Icons } from '@components/Icon';
import useTranslations from '@hooks/useTranslation';
import ButtonTemplate from '../../ui/Button/Button';
import ContentTemplate from '../../ui/Content/Content';
import { Icon, Input, Section } from './Search.elements';

export interface SearchProps {
    withoutMarginTop?: boolean;
    label?: string;
}

const SearchTemplate: FC<SearchProps> = ({ withoutMarginTop, label }) => {
    const { t } = useTranslations();

    const router = useRouter();

    const searchInputRef = useRef<HTMLInputElement>();

    const [searchStr, setSearchStr] = useState(router?.query?.search || '');

    useEffect(() => {
        const search = setTimeout(() => {
            if (searchStr.length >= 2) {
                router.push({
                    pathname: router.pathname,
                    query: { ...router.query, search: searchStr },
                });
            }

            if (searchStr === '' && router.query.search) {
                delete router.query.search;

                router.push({
                    pathname: router.pathname,
                    query: { ...router.query },
                });
            }
        }, 300);

        return () => clearTimeout(search);
    }, [searchStr]);

    useEffect(() => {
        searchInputRef.current.value = (router?.query?.search as string) || '';
    }, []);

    return (
        <Section withoutMarginTop={withoutMarginTop}>
            <Icon name={Icons.Search} />
            <Input
                onKeyUp={() => setSearchStr(searchInputRef.current.value)}
                ref={searchInputRef}
                placeholder={label || t('search.title')}
            />
        </Section>
    );
};

export default SearchTemplate;
